import React, { Component } from "react";
import { Col } from "react-bootstrap";
import Select from "react-select";
import CallType from "../Script/Template/CallType";
import AscComponent from "../../components/AscComponent";

/**
 * IVR履歴 スクリプト詳細設定セクション
 * 単独スクリプト選択時のみ有効。バージョン選択・ブロック種別フィルター・ブロック検索条件を提供する。
 */
export default class IvrHistoryScriptDetail extends AscComponent {

    getQuestionBranchOptions = (block) => {
        let { langText } = this.props;
        let options = [];
        let jsonData = block.json_data || {};

        if (jsonData.push_nums && Array.isArray(jsonData.push_nums)) {
            jsonData.push_nums.forEach(pn => {
                if (pn.number) {
                    options.push({
                        value: String(pn.number),
                        label: String(pn.number)
                    });
                }
            });
        }

        options.push({
            value: "__other__",
            label: langText.Body.IvrHistoryOther
        });

        return options;
    }

    render() {
        let {
            state,
            langText,
            getFilterData,
            onChange,
            onToggleScriptDetail,
            enabledBlocks,
            getBlockTypeLabel,
        } = this.props;

        let scriptFilter = state.script_name || [];
        let isSingleScript = scriptFilter.length === 1;
        let scriptLabel = isSingleScript ? scriptFilter[0].label : "";
        let isOpen = state.scriptDetailOpen;

        let versionOptions = isSingleScript ? (state.scriptVersionSelect || []) : [];
        let selectedVersions = getFilterData("script_versions") || [];

        let blockTypeOptions = isSingleScript && selectedVersions.length > 0
            ? (state.scriptBlockTypeSelect || [])
            : [];
        let selectedBlockTypes = state.block_type || [];
        let hasBlockSetting = selectedVersions.length > 0;

        return (
            <Col sm={12} md={12} className="padding-left-0 padding-right-0">
                <hr className="menu-hr" />
                <div className="ivr-detail-section">
                    <button
                        type="button"
                        className="ivr-detail-header"
                        onClick={() => { if (isSingleScript && onToggleScriptDetail) onToggleScriptDetail(); }}
                        disabled={!isSingleScript}
                    >
                        <div>
                            <div className="ivr-detail-header-title">
                                {langText.Body.IvrHistoryScriptDetailSetting}
                            </div>
                            <div className="ivr-detail-header-sub">
                                {isSingleScript
                                    ? this.sprintf(langText.Body.IvrHistoryScriptDetailDescription, scriptLabel)
                                    : langText.Body.IvrHistorySelectScriptFirst}
                            </div>
                        </div>
                        <span className="ivr-detail-header-toggle">{isOpen ? "－" : "＋"}</span>
                    </button>

                    {isOpen && (
                        <div className="ivr-detail-body">
                            {/* バージョン選択 */}
                            <div className="ivr-detail-group">
                                <div className="ivr-detail-group-label">{langText.Body.IvrHistoryVersion}</div>
                                <div className="ivr-version-list">
                                    <div className="ivr-version-header">
                                        <span>{scriptLabel}</span>
                                        <button
                                            type="button"
                                            className="ivr-all-btn"
                                            onClick={() => onChange(versionOptions, "script_version_all")}
                                        >
                                            ALL
                                        </button>
                                    </div>
                                    {versionOptions.length > 0 ? versionOptions.map(ver => (
                                        <label key={ver.value} className="ivr-version-row">
                                            <span>{"ver." + ver.label}</span>
                                            <input
                                                type="checkbox"
                                                checked={selectedVersions.some(sv => sv.value === ver.value)}
                                                onChange={() => onChange(ver, "script_version_toggle")}
                                            />
                                        </label>
                                    )) : (
                                        <div className="ivr-empty-text">---</div>
                                    )}
                                </div>
                            </div>

                            {blockTypeOptions.length > 0 ? (
                                <>
                                    {/* ブロック種別 */}
                                    <div className="ivr-detail-group">
                                        <div className="ivr-detail-group-label">{langText.Body.IvrHistoryBlockType}</div>
                                        <div className="ivr-version-list">
                                            <div className="ivr-version-header">
                                                <span></span>
                                                <button
                                                    type="button"
                                                    className="ivr-all-btn"
                                                    onClick={() => {
                                                        let isAllSelected = blockTypeOptions.every(bt => selectedBlockTypes.some(s => s.value === bt.value));
                                                        onChange(isAllSelected ? [] : blockTypeOptions, "block_type");
                                                    }}
                                                >
                                                    ALL
                                                </button>
                                            </div>
                                            <div className="ivr-blocktype-list">
                                                {blockTypeOptions.map(bt => (
                                                    <label key={bt.value} className="ivr-blocktype-row">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedBlockTypes.some(s => s.value === bt.value)}
                                                            onChange={() => {
                                                                let next = selectedBlockTypes.some(s => s.value === bt.value)
                                                                    ? selectedBlockTypes.filter(s => s.value !== bt.value)
                                                                    : [...selectedBlockTypes, bt];
                                                                onChange(next, "block_type");
                                                            }}
                                                        />
                                                        <span>{bt.label}</span>
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    {/* ブロック設定（全ブロック種別対応） */}
                                    {hasBlockSetting && (
                                        <div className="ivr-detail-group-label">{langText.Body.IvrHistoryBlockSetting}</div>
                                    )}
                                    {hasBlockSetting && selectedVersions.map(ver => {
                                        let versionBlocks = (state.scriptBlockData || {})[ver.value] || [];
                                        let filteredBlocks = selectedBlockTypes.length > 0
                                            ? versionBlocks.filter(block =>
                                                selectedBlockTypes.some(bt => bt.value === block.type)
                                            )
                                            : versionBlocks;
                                        if (filteredBlocks.length === 0) return null;
                                        let allBlocksChecked = filteredBlocks.every(block => {
                                            let bKey = "block_" + ver.value + "_" + block.id;
                                            let bType = Number(block.type);
                                            let checkable = bType === CallType.QUESTION || bType === CallType.NUMBER;
                                            if (checkable) return !!(enabledBlocks && enabledBlocks[bKey]) || !!getFilterData(bKey);
                                            return getFilterData(bKey) === "__exists__";
                                        });
                                        return (
                                            <div key={"ver-blocks-" + ver.value} className="ivr-detail-group">
                                                <div className="ivr-version-list">
                                                    <div className="ivr-version-header">
                                                        <span>{"ver." + ver.label}</span>
                                                        <button
                                                            type="button"
                                                            className="ivr-all-btn"
                                                            onClick={() => onChange({ versionId: ver.value, blocks: filteredBlocks, check: !allBlocksChecked }, "block_version_all")}
                                                        >
                                                            ALL
                                                        </button>
                                                    </div>
                                                    {filteredBlocks.map(block => {
                                                        let blockKey = "block_" + ver.value + "_" + block.id;
                                                        let bType = Number(block.type);
                                                        let isCheckable = bType === CallType.QUESTION || bType === CallType.NUMBER;
                                                        let isChecked = isCheckable
                                                            ? !!(enabledBlocks && enabledBlocks[blockKey]) || !!getFilterData(blockKey)
                                                            : getFilterData(blockKey) === "__exists__";
                                                        return (
                                                            <div key={blockKey} className="ivr-block-row">
                                                                <div className="ivr-block-row-top">
                                                                    <span className="ivr-block-row-label">
                                                                        <span className="ivr-block-row-num">{"#" + block.number}</span>
                                                                        <span className="ivr-block-row-type">{getBlockTypeLabel(block.type)}</span>
                                                                        {block.title && (
                                                                            <span className="ivr-block-row-name">{block.title}</span>
                                                                        )}
                                                                    </span>
                                                                    <label className="ivr-block-row-check">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={isChecked}
                                                                            onChange={e => {
                                                                                if (isCheckable) {
                                                                                    if (!e.target.checked) onChange("", blockKey);
                                                                                    else onChange(null, blockKey + "__enabled__");
                                                                                } else {
                                                                                    onChange(
                                                                                        e.target.checked ? "__exists__" : "",
                                                                                        blockKey
                                                                                    );
                                                                                }
                                                                            }}
                                                                        />
                                                                    </label>
                                                                </div>
                                                                {bType === CallType.QUESTION && (
                                                                    <Select
                                                                        value={getFilterData(blockKey) && (Array.isArray(getFilterData(blockKey)) || typeof getFilterData(blockKey) === "object") ? getFilterData(blockKey) : null}
                                                                        onChange={e => onChange(e && e.length > 0 ? e : "__exists__", blockKey)}
                                                                        options={this.getQuestionBranchOptions(block)}
                                                                        placeholder={langText.SelectOption.Placeholder}
                                                                        isClearable={true}
                                                                        isMulti={true}
                                                                        isDisabled={!isChecked}
                                                                        classNamePrefix="ivr-block-select"
                                                                    />
                                                                )}
                                                                {bType === CallType.NUMBER && (
                                                                    <input
                                                                        type="text"
                                                                        className="form-control ivr-block-row-input"
                                                                        value={typeof getFilterData(blockKey) === "string" && getFilterData(blockKey) !== "__exists__" ? getFilterData(blockKey) : ""}
                                                                        onChange={e => onChange(e.target.value === "" ? "__exists__" : e.target.value, blockKey)}
                                                                        placeholder={langText.Body.IvrHistoryPrefixSearch}
                                                                        disabled={!isChecked}
                                                                    />
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        );
                                    })}

                                    {/* 範囲（全ブロック/最終ブロック） */}
                                    <div className="ivr-detail-group">
                                        <div className="ivr-detail-group-label">{langText.Body.IvrHistoryBlockSearchScope}</div>
                                        <div className="ivr-condition-type-row">
                                            <button
                                                type="button"
                                                className={`ivr-condition-type-btn${state.blockSearchScope !== "last" ? " active" : ""}`}
                                                onClick={() => onChange("all", "block_search_scope")}
                                            >
                                                {langText.Body.IvrHistoryBlockAll}
                                            </button>
                                            <button
                                                type="button"
                                                className={`ivr-condition-type-btn${state.blockSearchScope === "last" ? " active" : ""}`}
                                                onClick={() => onChange("last", "block_search_scope")}
                                            >
                                                {langText.Body.IvrHistoryBlockLast}
                                            </button>
                                        </div>
                                    </div>

                                    {/* 複数条件（AND/OR）: 最終ブロック検索時は非表示 */}
                                    {state.blockSearchScope !== "last" && (
                                    <div className="ivr-detail-group">
                                        <div className="ivr-detail-group-label">{langText.Body.IvrHistoryBlockConditionType}</div>
                                        <div className="ivr-condition-type-row">
                                            <button
                                                type="button"
                                                className={`ivr-condition-type-btn${state.blockConditionType === "and" ? " active" : ""}`}
                                                onClick={() => onChange("and", "block_condition_type")}
                                            >
                                                {langText.Body.IvrHistoryBlockConditionAnd}
                                            </button>
                                            <button
                                                type="button"
                                                className={`ivr-condition-type-btn${state.blockConditionType === "or" ? " active" : ""}`}
                                                onClick={() => onChange("or", "block_condition_type")}
                                            >
                                                {langText.Body.IvrHistoryBlockConditionOr}
                                            </button>
                                        </div>
                                    </div>
                                    )}
                                </>
                            ) : (
                                <div className="ivr-empty-text">
                                    {selectedVersions.length === 0
                                        ? langText.Body.IvrHistorySelectVersionFirst
                                        : "---"}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </Col>
        );
    }
}
